import React from 'react';

const ListViewIcon = ({ fill }: { fill?: string }) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g fillRule="evenodd">
      <path
        d="M3 14h4v-4H3v4zm0 5h4v-4H3v4zM3 9h4V5H3v4zm5 5h13v-4H8v4zm0 5h13v-4H8v4zM8 5v4h13V5H8z"
        fill={fill}
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default ListViewIcon;
